// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"header_wrapper__WOgBy","logo":"header_logo__2ARX-","user-button":"header_user-button__1XZCD","icons":"header_icons__3Otoc","code":"header_code__1KUp-"};